import type {
  AccountUsecase,
  MessageUsecase,
  UserUsecase,
} from '@/apis/usecases'
import {
  AccountInteractor,
  MessageInteractor,
  UserInteractor,
} from '@/apis/usecases/interactors'
import { TYPES } from '@/libs/di/types'
import type { interfaces } from 'inversify'
import { ContainerModule } from 'inversify'

export const usecases = new ContainerModule((bind: interfaces.Bind) => {
  bind<AccountUsecase>(TYPES.AccountUsecase).to(AccountInteractor)
  bind<MessageUsecase>(TYPES.MessageUsecase).to(MessageInteractor)
  bind<UserUsecase>(TYPES.UserUsecase).to(UserInteractor)
})
